import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName, TextKey } from '@mews-commander/enums';
import {
    GuestExperienceWhitelistedUserEmails,
    isAllowedAccessEmailWhitelistingRoutes,
} from '@mews-commander/modules/src/modules/guestExperienceWhitelistedUserEmails';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/GuestExperience/WhitelistedUserEmails')({
    component: GuestExperienceWhitelistedUserEmailsComponent,
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    beforeLoad: () => {
        if (!isAllowedAccessEmailWhitelistingRoutes()) {
            throw notFound();
        }
    },
    staticData: {
        routeName: RouteName.GuestExperienceWhitelistedUserEmails,
        title: TextKey.WhitelistedUserEmailsDetailPageTitle,
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
    },
});

function GuestExperienceWhitelistedUserEmailsComponent() {
    const { OwnerId } = Route.useSearch();

    return <GuestExperienceWhitelistedUserEmails ownerId={OwnerId} />;
}
